module.exports = __webpack_public_path__ + "static/media/mars.b45b9f68.png";